import { useEffect, useMemo, useState } from 'react';
import styles from './promotionalFurnitureComponent.module.scss';
import promotionalFurnitureController from '../../../../../Api/promotionalFurnitureController';
import ListPartWithEditForm from './Components/ListPartWithEditForm/ListPartWithEditForm';
import CsvDownloadButton from 'react-json-to-csv';
import { useUser } from '../../../../../hooks/useUser';

const initialForm = { name: '', description: '', price: 0, crossed: 0, width: 0, height: 0, depth: 0, image: '', isPriceVissible: false };

export default function PromotionalFurnitureComponent() {
    const user = useUser();
    const [showAddForm, setShowAddForm] = useState(false);
    const [furnitureData, setFurnitureData] = useState([]);
    const [form, setForm] = useState(initialForm);
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const loadFurniture = async () => {
        setLoading(true); setError('');
        try {
            const res = await promotionalFurnitureController.getAllFurniture();
            setFurnitureData(res.furniture || []);
            if (!res.ok) setError(res.message);
        } catch {
            setError('Nie udało się pobrać promocji.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadFurniture(); }, []);

    const filteredFurniture = useMemo(() => {
        const phrase = query.trim().toLocaleLowerCase('pl');
        if (!phrase) return furnitureData;
        return furnitureData.filter((item) => `${item.name || ''} ${item.description || ''}`.toLocaleLowerCase('pl').includes(phrase));
    }, [furnitureData, query]);

    const change = (field, value) => setForm((current) => ({ ...current, [field]: value }));

    const addFurniture = async () => {
        if (!form.name.trim() || !form.image) {
            setError('Podaj nazwę i wybierz zdjęcie mebla.');
            return;
        }
        setError('');
        const res = await promotionalFurnitureController.addFurniture({ ...form, name: form.name.trim() });
        if (!res.ok) {
            setError(res.message);
            return;
        }
        if (res.newFurniture) setFurnitureData((current) => [...current, res.newFurniture]);
        setForm(initialForm);
        setShowAddForm(false);
    };

    const editFurniture = async (furniture) => {
        const res = await promotionalFurnitureController.editFurniture(furniture);
        if (!res.ok) {
            setError(res.message);
            return;
        }
        setFurnitureData((current) => current.map((item) => item._id === furniture._id ? (res.editedFurniture || item) : item));
    };

    const deleteFurniture = async (_id) => {
        if (!window.confirm('Usunąć ten mebel promocyjny?')) return;
        const res = await promotionalFurnitureController.deleteFurniture(_id);
        if (!res.ok) {
            setError(res.message);
            return;
        }
        setFurnitureData((current) => current.filter((item) => item._id !== _id));
    };

    const exportData = furnitureData.map(({ __v, ...item }) => item);

    return <div className={styles.general}>
        <div className={styles.moduleHeader}>
            <div><h2>Promocje</h2><p>Zarządzaj meblami promocyjnymi, cenami, opisami i widocznością.</p></div>
            <span className={styles.counter}>{furnitureData.length} pozycji</span>
        </div>
        <div className={styles.toolbar}>
            <input aria-label="Szukaj promocji" placeholder="Szukaj po nazwie lub opisie…" value={query} onChange={(event) => setQuery(event.target.value)} />
            <div className={styles.actions}>
                <CsvDownloadButton data={exportData} filename="promocje.csv">Eksportuj CSV</CsvDownloadButton>
                <button type="button" onClick={loadFurniture}>Odśwież</button>
                {user.hasPermission('promotions.create') && <button type="button" className={styles.primaryButton} onClick={() => setShowAddForm((current) => !current)}>{showAddForm ? 'Anuluj' : 'Dodaj promocję'}</button>}
            </div>
        </div>
        {error && <div className={styles.error}>{error}</div>}
        {showAddForm && <div className={styles.formContainer}>
            <label>Nazwa<input value={form.name} onChange={(event) => change('name', event.target.value)} /></label>
            <label>Cena<input type="number" value={form.price} onChange={(event) => change('price', Number(event.target.value))} /></label>
            <label>Cena skreślona<input type="number" value={form.crossed} onChange={(event) => change('crossed', Number(event.target.value))} /></label>
            <label>Szerokość<input type="number" value={form.width} onChange={(event) => change('width', Number(event.target.value))} /></label>
            <label>Wysokość<input type="number" value={form.height} onChange={(event) => change('height', Number(event.target.value))} /></label>
            <label>Głębokość<input type="number" value={form.depth} onChange={(event) => change('depth', Number(event.target.value))} /></label>
            <label className={styles.fileField}>Zdjęcie<input type="file" accept="image/*" onChange={(event) => change('image', event.target.files?.[0] || '')} /></label>
            <label className={styles.checkbox}><input type="checkbox" checked={form.isPriceVissible} onChange={(event) => change('isPriceVissible', event.target.checked)} /> Wyświetlaj cenę</label>
            <label className={styles.description}>Opis<textarea value={form.description} onChange={(event) => change('description', event.target.value)} /></label>
            <button type="button" className={styles.primaryButton} onClick={addFurniture}>Zapisz promocję</button>
        </div>}
        {loading ? <div className={styles.state}>Pobieranie promocji…</div> : filteredFurniture.length === 0 ? <div className={styles.state}>Brak promocji pasujących do wyszukiwania.</div> : <div className={styles.furnituresDataContainer}>
            {filteredFurniture.map((item) => <ListPartWithEditForm key={item._id} {...item} imageToShow={item.image} onDelete={deleteFurniture} onEdit={editFurniture} canEdit={user.hasPermission('promotions.update')} canDelete={user.hasPermission('promotions.delete')} />)}
        </div>}
    </div>;
}
